import { render, staticRenderFns } from "./account.vue?vue&type=template&id=7cd6563e"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cd6563e')) {
      api.createRecord('7cd6563e', component.options)
    } else {
      api.reload('7cd6563e', component.options)
    }
    module.hot.accept("./account.vue?vue&type=template&id=7cd6563e", function () {
      api.rerender('7cd6563e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/settings/account.vue"
export default component.exports